export enum ReportType {
    FAKE_DATA = 'fake_data',
    UNREACHABLE = 'unreachable',
    UNAVAILABLE = 'unavailable',
}
